import React from 'react';
import {
  Table, Dropdown,
} from 'semantic-ui-react';

const VRAPendingRow = actionHandler => vraPending => {
  if (!vraPending) return null;

  const rowMenuOptions = [
    { key: 1, text: 'View Detail', value: 'view' },
    { key: 2, text: 'Allow', value: 'allow' },
    { key: 3, text: 'Invalidate', value: 'invalidate' },
  ];
  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, vraPending);
  };
  const id = vraPending?.id;
  const odometerOnReturn = vraPending?.odometerOnReturn;
  const returnInitiatedAt = vraPending?.returnInitiatedAt;
  const expirationDate = vraPending?.expirationDate;
  const purchasePrice = vraPending?.transaction?.purchasePrice;
  const username = vraPending?.returningUser?.username;
  const dealerName = vraPending?.guaranteePurchase?.guaranteeOffer?.dealerName;
  const vin = vraPending?.guaranteePurchase?.guaranteeOffer?.vehicleInformation?.vin;
  const dealerNumber = vraPending?.guaranteePurchase?.guaranteeOffer?.auctionInformation?.dealerNumber;
  const name = vraPending?.auctionLocation?.name;
  const pendingReasons = vraPending?.pendingReasons ?? [];

  return (
    <Table.Row key={id}>
      <Table.Cell>{id}</Table.Cell>
      <Table.Cell>{vin}</Table.Cell>
      <Table.Cell>{dealerNumber}</Table.Cell>
      <Table.Cell>{dealerName}</Table.Cell>
      <Table.Cell>{name}</Table.Cell>
      <Table.Cell>{odometerOnReturn}</Table.Cell>
      <Table.Cell>{purchasePrice}</Table.Cell>
      <Table.Cell>{returnInitiatedAt}</Table.Cell>
      <Table.Cell>{expirationDate}</Table.Cell>
      <Table.Cell>{pendingReasons.length === 0 ? '' : pendingReasons.map(pendingReason => pendingReason.notice).join(', ')}</Table.Cell>
      <Table.Cell>{username}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default VRAPendingRow;
